import { render } from "./SelectTwo.vue?vue&type=template&id=2088003a"
import script from "./SelectTwo.vue?vue&type=script&lang=js"
export * from "./SelectTwo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__